import type { MenuVersionsItemsProps } from '@/interface/Menu';
import { usePathname } from 'next/navigation';
import { Fragment, useMemo, type FC } from 'react';
import { fallbackMenu } from '@/interface/Menu/mocks';
import { useGetCustomerStatus } from '@/modules/Customer/http/client/useGetCustomerStatus';
import useLocalStorage from '@/hooks/useLocalstorage';
import { MenuItem } from './Item';
import { MenuSectionTitle } from './Separator';
import 'external-svg-loader';
interface MenuItemsListProps {
  isMenuOpen?: boolean;
  handleMenuItemClick: (url: string) => void;
  unauthorized?: boolean;
}
export const MenuItemsList: FC<MenuItemsListProps> = ({
  isMenuOpen = false,
  unauthorized = false,
  handleMenuItemClick
}) => {
  const pathname = usePathname();
  const [menuVersion] = useLocalStorage<MenuVersionsItemsProps[]>('menuVersions', []);
  const {
    data: customer
  } = useGetCustomerStatus();
  const menuItems = useMemo(() => {
    const menuData = menuVersion.length ? menuVersion : fallbackMenu;
    return menuData.map(item => {
      if (isEqiRestrictedItem(item.name) && !customer?.isEqi) {
        return <Fragment key={crypto.randomUUID()} />;
      }
      return mountMenuItem(item, {
        pathname,
        isMenuOpen,
        unauthorized,
        handleMenuItemClick
      });
    });
  }, [customer, handleMenuItemClick, isMenuOpen, menuVersion, pathname, unauthorized]);
  if (!menuVersion.length) {
    return null;
  }
  return menuItems;
};
const isEqiRestrictedItem = (name: string): boolean => {
  return ['Assessoria Renda Variável', 'Minha Assessoria'].includes(name);
};
const mountMenuItem = (item: MenuVersionsItemsProps, props: {
  pathname: string;
  isMenuOpen: boolean;
  unauthorized: boolean;
  handleMenuItemClick: (url: string) => void;
}) => {
  const {
    iconName,
    name,
    status,
    target,
    url
  } = item;
  const {
    pathname,
    isMenuOpen,
    unauthorized,
    handleMenuItemClick
  } = props;
  if (status === 'separator') {
    return <MenuSectionTitle key={`menu-section-${name}`} isMenuOpen={isMenuOpen} name={name} />;
  }
  return <MenuItem key={`menu-item-${name}`} iconName={iconName} isActive={pathname === url} isMenuOpen={isMenuOpen} name={name} target={target} url={url} unauthorized={unauthorized} onClick={handleMenuItemClick} data-sentry-element="MenuItem" data-sentry-component="mountMenuItem" data-sentry-source-file="index.tsx" />;
};